module.exports = __webpack_public_path__ + "img/samspitze.f2e3c352.jpg";